import React, { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import LobbyEntry from '../components/LobbyEntry'
import LobbyOverlay from '../components/LobbyOverlay'
import PageWithBg from '../components/PageWithBg'
import config from '../config'
import Amplitude from '../utils/amplitudeHelper'
import LoadIcon from '../components/LoadIcon'

const PageWrapper = styled.div`
  .mid-trailer {
    /* background-color: black; */
    position: absolute;
    top: 20%;
    left: 35.7%;
    right: 35.7%;
    bottom: 64.4%;
  }
  .left-trailer {
    /* background-color: black; */
    position: absolute;
    top: 21.2%;
    right: 58.3%;
    left: 4.7%;
    bottom: 63.9%;
  }
  .right-trailer {
    /* background-color: black; */
    position: absolute;
    top: 21.1%;
    left: 57.3%;
    right: 2.7%;
    bottom: 63.9%;
  }
`

export default function LobbyPage({ currentUser }) {
  const [overlayTitle, setOverlayTitle] = useState('Select hall to enter:')
  const [overlay, setOverlay] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const showEntryOverlay = (destinations) => {
    setOverlay(destinations)
  }

  const hideOverlay = () => setOverlay(null)

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      hideOverlay()
    }
  }, [])

  const showHelpDesk = () => {
    // const cpt = window.chaport
    // cpt.on('ready', function () {
    //   cpt.setVisitorData({
    //     name: currentUser.fullName,
    //     email: currentUser.email,
    //   })
    //   cpt.open()
    // })
    // cpt.on('collapsed', function () {
    //   cpt.close()
    // })
    // Amplitude.clickHelpDesk()
    toast('Help Desk is currently closed.')
  }

  useEffect(() => {
    document.title = `${config.eventName} | Lobby`
  }, [])

  useEffect(() => {
    Amplitude.visit('Lobby')
  }, [currentUser.id])

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)

    return () => {
      document.removeEventListener('keydown', escFunction, false)
    }
  }, [escFunction])

  return (
    <>
      {isLoading && <LoadIcon />}
      <PageWrapper>
        <PageWithBg bgImg={config.assets.lobby.landscape}>
          <LobbyOverlay overlayTitle={overlayTitle} overlay={overlay} hideOverlay={hideOverlay} />
          {config.lobbyEntries.map((entry) => {
            // temporary hardcoded for KFAIR20 access
            // if (entry.id === 'auditorium') {
            //   const audOptions = [...entry.destination]

            //   if (currentUser?.role === 'manager') {
            //     entry.destination = [audOptions[0], audOptions[1]]
            //   }

            //   if (currentUser?.role === 'non_manager') {
            //     entry.destination = [audOptions[0]]
            //   }
            // }

            return <LobbyEntry showHelpDesk={showHelpDesk} key={entry.id} setOverlayTitle={setOverlayTitle} showEntryOverlay={showEntryOverlay} {...entry} />
          })}
          <div className="left-trailer">
            <iframe
              width="100%"
              height="100%"
              title="Event Trailer"
              src="https://player.vimeo.com/video/595053600?h=cba25ca09d&autoplay=1&loop=1&muted=1&autopause=0&fs=1"
              allow="autoplay; fullscreen"
              allowFullScreen="true"
              webkitAllowFullScreen="true"
              mozAllowFullScreen="true"
              frameBorder="0"
              onLoad={() => {
                setIsLoading(false)
              }}
            />
          </div>
          <div className="mid-trailer">
            <iframe
              width="100%"
              height="100%"
              title="Event Trailer"
              src="https://player.vimeo.com/video/595053632?h=82c2297528&autoplay=1&loop=1&muted=1&autopause=0&fs=1"
              allow="autoplay; fullscreen"
              allowFullScreen="true"
              webkitAllowFullScreen="true"
              mozAllowFullScreen="true"
              frameBorder="0"
              onLoad={() => {
                setIsLoading(false)
              }}
            />
          </div>

          <div className="right-trailer">
            <iframe
              width="100%"
              height="100%"
              title="Event Trailer"
              src="https://player.vimeo.com/video/595053662?h=cbc09403dc&autoplay=1&loop=1&muted=1&autopause=0&fs=1"
              allow="autoplay; fullscreen"
              allowFullScreen="true"
              webkitAllowFullScreen="true"
              mozAllowFullScreen="true"
              frameborder="0"
              onLoad={() => {
                setIsLoading(false)
              }}
            />
          </div>
        </PageWithBg>
      </PageWrapper>
    </>
  )
}
